var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',{staticClass:"rs-task-list"},[_c('div',{staticClass:"litigation-wrapper"},[_c('div',{staticClass:"title"},[_vm._v("应诉方案")]),_c('fee-table',{attrs:{"initialPlan":_vm.initialPlan,"order":{
				includeFormType: _vm.params && _vm.params.includeFormType,
				death: _vm.params && _vm.params.death,
			}},on:{"handleCancel":_vm.handleCancel,"handleSubmit":_vm.handleSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }